import React from 'react';
import { SelectOption } from 'global';

import { Finance } from './finance/Finance';
import { FinanceFormValues } from './types';

interface Props {
  financeAmount: number;
  netInvoiceAmount: number;
  maxApprovalAmount: number;
  isFPOptionsLoading: boolean;
  financeProgramOptions: SelectOption[];
  onFetchFinanceProgram: (programId: string) => Promise<Partial<FinanceFormValues['financeQuote']>>;
}

export const FinanceStructure = ({
  financeAmount,
  netInvoiceAmount,
  maxApprovalAmount,
  isFPOptionsLoading,
  financeProgramOptions,
  onFetchFinanceProgram,
}: Props) => (
  <Finance
    financeAmount={financeAmount}
    netInvoiceAmount={netInvoiceAmount}
    maxApprovalAmount={maxApprovalAmount}
    isFPOptionsLoading={isFPOptionsLoading}
    onFetchFinanceProgram={onFetchFinanceProgram}
    financeProgramOptions={financeProgramOptions}
  />
);
